"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconcileSignerRequestSchema = exports.SignRequestSchema = exports.BackendSignRequestSchema = exports.SignerStatusEnum = void 0;
const zod_1 = require("zod");
const packet_tag_1 = require("./packet_tag");
var SignerStatusEnum;
(function (SignerStatusEnum) {
    SignerStatusEnum["PENDING"] = "pending";
    SignerStatusEnum["SIGNED"] = "signed";
    SignerStatusEnum["REFUSED"] = "refused";
})(SignerStatusEnum = exports.SignerStatusEnum || (exports.SignerStatusEnum = {}));
exports.BackendSignRequestSchema = zod_1.z.object({
    timezone: zod_1.z.string().min(1),
    longitude: zod_1.z.string().optional(),
    latitude: zod_1.z.string().optional(),
});
exports.SignRequestSchema = exports.BackendSignRequestSchema.extend({
    ip_address: zod_1.z.string().min(1),
    timestamp: zod_1.z.string().min(1),
});
exports.ReconcileSignerRequestSchema = zod_1.z.object({
    creditor_id: zod_1.z.string().min(1),
    old_tags: zod_1.z.array(packet_tag_1.PacketTagSchema),
    current_tags: zod_1.z.array(packet_tag_1.PacketTagSchema),
});
